import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";

const PrivateRoute = ({ Component,socket }) => {
  const authToken = useSelector((state) => state.auth.user?.jwtToken);
  return authToken ? <Component socket={socket} />  : <Navigate to="/" />;
};
export default PrivateRoute;
